<template>
  <v-row>
    <v-col cols="12"> 
      <v-sheet 
        outlined
        >
        <v-row class="pa-4">

          <v-col 
            cols="12">
            <v-data-table
              :headers="headers"
              :items="likes"
              :items-per-page="50"
                  :footer-props="{
                    'items-per-page-options': [20, 50, 100, 200],
                    'items-per-page-text':'Filas por página',
                  }"
              mobile="true"
            >
              <template v-slot:item.user="{ item }">
                {{ item.user.lastname.toUpperCase() + ', ' +item.user.name }}
              </template>

              <template v-slot:item.email="{ item }">
                {{ item.user.email }}
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatearFecha(item.created_at) }}
              </template>

            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading_entrepreneurships"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'showLikesOrganizer',
    data: () => ({
      loading:true,
      loading_entrepreneurships:false,
      
      dialog:false,
      name:'',

      editions:[],
      edition_id:null,

      entrepreneurship_id:null,
      likes:[], 

      headers: [
        {
          text: '# ID',
          align: 'center',
          filterable: true,
          value: 'id',
          width:'10%'
        },
        {
          text: 'Emprendedor/Participante',
          align: 'start',
          filterable: true,
          value: 'user',
          width:'30%'
        },
        {
          text: 'Correo electrónico',
          align: 'start',
          filterable: true,
          value: 'email',
          width:'30%'
        },
        { 
          text: 'Fecha',
          align: 'center',
          filterable: false,
          value: 'created_at',
          width:'30%'
        },
      ]
    }),

    methods:{
      async getEntrepreneurshipLikes()
      {
        this.loading_entrepreneurships=true
        await axios.get('organizer/entrepreneurships/'+this.entrepreneurship_id+'/likes').then(response =>{
          this.likes = response.data.data.likes
          this.loading_entrepreneurships=false
          this.show=true
        }).catch(error => {
          console.log(error);
          this.loading=false
        })
      },

      formatearFecha(fecha) {
        // Parsea la fecha en el formato "YYYY-MM-DD HH:MM:SS"
        var fechaParseada = new Date(fecha);

        // Obtiene las partes de la fecha
        var horas = fechaParseada.getHours();
        var minutos = fechaParseada.getMinutes();
        var segundos = fechaParseada.getSeconds();
        var dia = fechaParseada.getDate();
        var mes = fechaParseada.getMonth() + 1; // Sumamos 1 porque los meses en JavaScript van de 0 a 11
        var año = fechaParseada.getFullYear();

        // Agrega ceros delante si es necesario para mantener el formato de dos dígitos
        if (horas < 10) horas = '0' + horas;
        if (minutos < 10) minutos = '0' + minutos;
        if (segundos < 10) segundos = '0' + segundos;
        if (dia < 10) dia = '0' + dia;
        if (mes < 10) mes = '0' + mes;

        // Formatea la fecha como "HH:MM:SS DD/MM/YYYY"
        var fechaFormateada = `${horas}:${minutos}:${segundos} ${dia}/${mes}/${año}`;

        return fechaFormateada;
      }
    },

    created(){
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id
      this.getEntrepreneurshipLikes()
    },
  }
</script>